import React from 'react'
import './style.css'

const TritronikEmptyPanel = () => {
  return (
    <div className='container-empty'></div>
  )
}

export default TritronikEmptyPanel